import { Link } from "react-router-dom";
import { BookOpen } from "@phosphor-icons/react";

// Contextual "Learn more" link into the in-app guide (login-only), scrolls to a section.
export default function GuideLink({ section, label = "Learn more", className = "" }) {
  return (
    <Link
      data-testid={`guide-link-${section}`}
      to={`/app/guide#${section}`}
      className={`inline-flex items-center gap-1.5 text-xs font-medium text-[#1F6FE5] hover:underline ${className}`}
    >
      <BookOpen size={14} weight="duotone" /> {label}
    </Link>
  );
}
